export default __webpack_public_path__ + "static/Bitter-Black-e4a688fe20e59bfb0e6bc74c6b35565d.woff2";